import { Inject, Injectable } from '@angular/core';
import { ENDPOINTS, OnlineOnlyService, UriUtilitiesService } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable } from 'rxjs';
import { OdataEquipmentsModel } from '../../interfaces/equipments-odata.interface';

@Injectable({
    providedIn: 'root',
})
export class EquipmentService {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly uriUtilities: UriUtilitiesService,
        private readonly onlineOnlyService: OnlineOnlyService,
    ) {}

    public getEquipmentsByMatSer(materialNumber: string, serialNumber: string): Observable<OdataEquipmentsModel[]> {
        let query = ENDPOINTS.GetEquipmentsAndInterims.toString();
        const filter = `Material eq '${materialNumber}' and SerialNo eq '${serialNumber}'`;
        query = this.uriUtilities.appendFilterValue(query, filter);
        query = this.addExpansionAndFormatToQuery(query);
        // Todo: use storage service to store the response for offline capabilities same as of forms-read.service OR service workers
        return this.onlineOnlyService.get(query) as Observable<OdataEquipmentsModel[]>;
    }

    public getEquipmentsByOrder(orderNumber: string): Observable<OdataEquipmentsModel[]> {
        let query = ENDPOINTS.GetEquipmentsAndInterims.toString();
        const filter = `OrderNo eq '${orderNumber}'`;
        query = this.uriUtilities.appendFilterValue(query, filter);
        query = this.addExpansionAndFormatToQuery(query);
        return this.onlineOnlyService.get(query) as Observable<OdataEquipmentsModel[]>;
    }

    private addExpansionAndFormatToQuery(query: string): string {
        const expand = '$expand=EquipmentsSet,InterimProtocolsSet';
        const format = '$format=json';
        query = this.uriUtilities.appendParameter(query, expand);
        query = this.uriUtilities.appendParameter(query, format);
        return query;
    }
}
